import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VITE_API_URL } from '@/processENV';
import { handleJoinMeetLink } from '@/features/calendar/utils/meetLinkHelper';
export const useDeepLink = () => {
   const dispatch = useDispatch();

   useEffect(() => {
      const pathname = window.location.pathname;
      const meetLinkMatch = pathname.match(/^\/call-([a-zA-Z0-9]{3}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{3})$/);
      if (meetLinkMatch) {
         const token = meetLinkMatch[1];
         const apiBase = VITE_API_URL.replace('/api/v1', '') + '/call/';
         const fullLink = `${apiBase}${token}`;

         handleJoinMeetLink(fullLink, dispatch);
         window.history.replaceState({}, '', '/');
      }
   }, [dispatch]);
};
